import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { cartStore } from '../../_stores/cart-store';
import { SignalWatcher } from '@lit-labs/signals';

@customElement('cart-prop')
export class CartProp extends SignalWatcher(LitElement) {

    @property({ type: String })
    name: string = '';

    render() {
        const cartData = cartStore.data.get();
        return html`
            ${ cartData?.[this.name] }
        `;
    }

    createRenderRoot() { 
        return this;
    }
}